import routes from '../../config/routes';

export const hasSubNavForPath = (pathname: string): boolean => {
  const topRoute = routes.find((r) => {
    if (!r.path || r.path === '/' || r.path === '*' || r.layout === false) {
      return false;
    }
    return r.path === pathname || pathname.startsWith(`${r.path}/`);
  });

  if (!topRoute || !topRoute.routes) {
    return false;
  }

  return topRoute.routes.some((sub: any) => sub.name && !sub.hideInMenu);
};
